import { useState } from 'react';

/**
 * THE EMAIL AS A PLAYER RECEIVES IT — the branded HTML the API renders, shown in a frame so its
 * inline styles cannot leak into the page or the page's into it (owner, 2026-10-05: preview what
 * players get, not a description of it). Sandboxed with nothing allowed: no scripts, no forms.
 */
export function EmailPreviewFrame({ html, title }: { html: string; title: string }) {
  const [height, setHeight] = useState(900);
  return (
    <iframe
      title={title}
      srcDoc={html}
      /* Same-origin so its height can be read; still no scripts, forms or popups. */
      sandbox="allow-same-origin"
      onLoad={(event) => {
        const doc = event.currentTarget.contentDocument;
        if (doc) setHeight(doc.documentElement.scrollHeight + 4);
      }}
      style={{ height }}
      className="block w-full rounded-md border border-light bg-chalk"
    />
  );
}

/** Her own line, above her sign-off — parking, a change of room. Optional; empty adds nothing. */
export function DirectorNoteField({ value, onChange, id }: { value: string; onChange: (value: string) => void; id: string }) {
  return (
    <label htmlFor={id} className="flex flex-col gap-1.5 text-[14px] font-medium text-ink">
      Add a note (optional)
      <textarea
        id={id}
        value={value}
        maxLength={500}
        rows={3}
        onChange={(event) => onChange(event.target.value)}
        className="rounded-md border border-control-border bg-paper px-3 py-2 text-[15px] font-normal leading-relaxed"
      />
    </label>
  );
}
